<template>
    <v-sheet v-if="showChart" color="transparent" class="containerAreaSheet" v-click-outside="{handler: onClickOutside}" @click="activeClick">
        <Chart :class="isactive ? 'borderActive' : ''" :constructorType="'stockChart'" class="hc" :options="finalOptions" ref="chart"></Chart>
        <v-sheet v-if="!isactive" class="areaChartSheet" ></v-sheet>
    </v-sheet>
</template>

<script setup lang="ts">
import { ref, Ref, onMounted, onUnmounted, computed }    from 'vue';
/********************************
 ********** COMPONENTS **********
 *******************************/
import { Chart } from 'highcharts-vue';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getOptionsInGraphs } from '@/functions/project';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTGRAPHS from '@/constants/graphs';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme } from 'vuetify';
const theme = useTheme();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
    arrayItems: { required:true, type: Array }, arrayNames: { required:true, type: Array},
    title: { required:true, type:String }
})

const finalARRAYITEMS       = ref(props.arrayItems);
const finalARRAYNAMES       = ref(props.arrayNames);
const finalObjs:Ref<any[]>         = ref([]);
const showChart = ref(false)
const zones = ref<any>(CONSTGRAPHS.ZONES[props.title])

const tooltip:any =  props.title === 'Reset' ? {
    formatter: function(){
         return t('labels.latency')+ `: <b>` +(this.y??0) + ' ms' ;
    },
    
} : { valueDecimals: 2 };

const yAxisTitle            = ref(CONSTGRAPHS.YAXISLABEL[props.title] || '');
const colorText             = computed(() => theme.global.current.value.colors.colorText)

const finalYAxis = ref({
    
    title: {
        text: yAxisTitle,
        style:{ color: colorText }
    },
    style: { color: colorText }
})

const finalTitle = computed(() => props.title)


const seriesValue = ref(finalObjs.value)
/**
 * getOptionsInGraphs(tipo, serie, titulo, subtitulo, ocultar leyenda, altura, tooltip, yaxis)
 */
const finalOptions:any = ref(getOptionsInGraphs('line',seriesValue.value,props.title === 'Reset' ? 'Latencia' : finalTitle.value ,'',true,550,tooltip, finalYAxis));

const getAllData = async() => {
    for(let i=0; i<finalARRAYITEMS.value.length; i++ ){
        finalObjs.value.push(
            {
                name: finalARRAYNAMES.value[i],
                data: finalARRAYITEMS.value[i],
                zones: zones.value,
            },
        )
    }
}


const chartRef = ref<any>();
const duplicateChart = ref();

onMounted(async () => {
    await getAllData();
    showChart.value = true;
    setTimeout(() => {
        duplicateChart.value = chartRef.value;
    }, 500);
})

onUnmounted(() => {
    if(duplicateChart.value){
        duplicateChart.value.chart.destroy();
    }
});



const isactive = ref(false);

const onClickOutside = () => {
    isactive.value = false;
}

const activeClick = () =>{
    isactive.value = true;
}

</script>